import { Pipe, PipeTransform } from "@angular/core";
import { LanguageService, resolveLocalizedString } from "@mypxplat/xplat/core";

/**
 * Renders a per-locale map (or legacy bare string) as the best-fit string for the
 * current language, falling back to English then any available value then an optional
 * caller-supplied fallback. Reactive to `LanguageService.selectedLanguage` changes.
 *
 * Usage:
 *   {{ channel.title | localize }}
 *   {{ channel.description | localize: 'No description' }}
 *
 * DENG-728 follow-up — channel titles moved to DynamoDB with per-locale maps so admins
 * can auto-translate; consumers use this pipe to display them.
 */
@Pipe({
  name: "localize",
  standalone: false,
  pure: false, // language can change mid-session (settings picker), rerender when it does.
})
export class LocalizePipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(value: any, fallback: string = ""): string {
    const lang = this.languageService.selectedLanguage?.code || "en";
    return resolveLocalizedString(value, lang, fallback);
  }
}
